export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/index.vue'),
    children: [
      {
        path: ':databaseId',
        name: 'database',
        component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/index/[databaseId].vue'),
        children: [
          {
            path: ':tableId',
            name: '//[databaseId]/[tableId]',
            component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/index/[databaseId]/[tableId].vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "layout": "sidenav"
    }
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/billing.vue'),
    /* no children */
    meta: {
      "layout": "sidenav"
    }
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/row',
    name: '/row',
    component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/row.vue'),
    /* no children */
  },
  {
    path: '/upgrade',
    name: 'upgrade',
    component: () => import('/home/zhouxuefeng/projects/base/apps/contents/src/pages/upgrade.vue'),
    /* no children */
    meta: {
      "layout": "sidenav"
    }
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

